import type { FormPhoneInputProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { PhoneNumberInput } from '@/components/PhoneNumberInput';

import { FormFieldShell } from '../FormFieldShell';

export const FormPhoneInput = <TFieldValues extends FieldValues = FieldValues>(
  props: FormPhoneInputProps<TFieldValues>,
) => {
  const {
    name,
    label,
    hint,
    description,
    isRequired,
    defaultCountry = 'UA',
    disabled,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <PhoneNumberInput
          id={fieldId}
          value={field.value || ''}
          onChange={field.onChange}
          label={label}
          aria-label={label}
          isRequired={isRequired}
          hint={hint}
          defaultCountry={defaultCountry}
          disabled={disabled}
          isInvalid={fieldState.invalid}
        />
      )}
    />
  );
};
